import { SimpleInputController } from './simple-input.controller'

const component = {
  templateUrl: '/workflow/components/simple-input/simple-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: SimpleInputController
}

export const simpleInput = component
